import api from './api';

class MembershipService {
  async getAllPlans(params = {}) {
    const response = await api.get('/memberships/plans', { params });
    return response.data;
  }

  async getPlanById(id) {
    const response = await api.get(`/memberships/plans/${id}`);
    return response.data;
  }

  async createPlan(data) {
    const response = await api.post('/memberships/plans', data);
    return response.data;
  }

  async updatePlan(id, data) {
    const response = await api.put(`/memberships/plans/${id}`, data);
    return response.data;
  }

  async deletePlan(id) {
    const response = await api.delete(`/memberships/plans/${id}`);
    return response.data;
  }

  async togglePlanStatus(id, is_active) {
    const response = await api.patch(`/memberships/plans/${id}/status`, { is_active });
    return response.data;
  }

  // Membership History Management
  async getAllMemberships(params = {}) {
    const response = await api.get('/memberships/history', { params });
    return response.data;
  }

  async getMembershipById(id) {
    const response = await api.get(`/memberships/history/${id}`);
    return response.data;
  }

  async getMemberMemberships(memberId) {
    const response = await api.get(`/members/${memberId}/memberships`);
    return response.data;
  }

  async updateStartDate(membershipId, startDate) {
    const response = await api.patch(`/memberships/history/${membershipId}/start-date`, {
      start_date: startDate
    });
    return response.data;
  }

  async cancelMembership(membershipId) {
    const response = await api.patch(`/memberships/history/${membershipId}/cancel`);
    return response.data;
  }

  async getMembershipStats() {
    const response = await api.get('/memberships/stats');
    return response.data;
  }

  // Membership Upgrade
  async getUpgradeOptions(memberId) {
    const response = await api.get(`/memberships/upgrade/options/${memberId}`);
    return response.data;
  }

  async upgradeMembership(memberId, data) {
    const response = await api.post(`/memberships/upgrade/${memberId}`, data);
    return response.data;
  }
}

export default new MembershipService();
